/* @flow */
import * as React from 'react';

import './divider.css';

export function And() {
    return <div styleName='divider'>and</div>;
}
